import { Button, Popconfirm } from "antd";
import { usePrepareForNamesMutation } from "../../../utils/usePrepareForNamesMutation";

export const ResetButton = () => {
  const resetMutation = usePrepareForNamesMutation();
  return (
    <div
      style={{
        display: "block",
        right: -72,
        top: 250,
        zIndex: 30,
        position: "absolute",
        transform: "rotate(270deg)",
      }}
    >
      <Popconfirm
        onConfirm={() => resetMutation.mutate()}
        title={"Willst du das Spiel wirklich zurücksetzen?"}
      >
        <Button danger type={"primary"}>
          Spiel zurücksetzen 💣
        </Button>
      </Popconfirm>
    </div>
  );
};
